export default "__VITE_ASSET__DNoPwX1g__"